// extracted by mini-css-extract-plugin
var _1 = "associationTables_associationTables";
var _2 = "associationTables_buttons";
var _3 = "associationTables_wrapper";
export { _1 as "associationTables", _2 as "buttons", _3 as "wrapper" }
